import { render, staticRenderFns } from "./conversion-table.vue?vue&type=template&id=3508fa16"
import script from "./conversion-table.vue?vue&type=script&lang=js"
export * from "./conversion-table.vue?vue&type=script&lang=js"
import style0 from "./conversion-table.vue?vue&type=style&index=0&id=3508fa16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports